import React from "react";

type Props = { buildingFloorId?: string; userBuildingFloorId?: string };

export default function IotWorkingFloor({
  buildingFloorId,
  userBuildingFloorId,
}: Props) {
  if (
    !buildingFloorId ||
    !userBuildingFloorId ||
    buildingFloorId !== userBuildingFloorId
  ) {
    return null;
  }

  return (
    <div className="text-xs font-semibold text-white py-px px-2 rounded-full bg-brand-primary-magenta">
      근무층
    </div>
  );
}
